import { Module } from "vuex";

import { PatientsApi } from "@/api/patients";
import { PostPatientBody, ReAssignPatient, RootState } from "@/types";

interface PatientsState {
  patients: any[];
  practitionerOwnPatients: any[];
}

export const patients: Module<PatientsState, RootState> = {
  namespaced: true,
  state: {
    patients: [],
    practitionerOwnPatients: [],
  },
  mutations: {
    setPatients(state, payload) {
      state.patients = payload;
    },
    setPractitionersPatients(state, payload) {
      state.practitionerOwnPatients = payload;
    },
  },
  actions: {
    async getAllPatients(ctx) {
      const patients = await PatientsApi.getPatients();
      ctx.commit("setPatients", patients);
    },
    async signUpPatient(ctx, payload: PostPatientBody) {
      await PatientsApi.signUpPatient(payload);
    },
    async getAllByPractitionerId(ctx, id?: string) {
      const { uid } = ctx.rootGetters;
      const practitionerOwnPatients = await PatientsApi.getAllByPractitionerId(id || uid);
      ctx.commit("setPractitionersPatients", practitionerOwnPatients);
    },
    async reAssignPatient(ctx, payload: ReAssignPatient) {
      await PatientsApi.updatePractitioner(payload.patientId, payload.practitionerId);
    },
  },
  getters: {
    patients(state) {
      return state.patients;
    },
    practitionerOwnPatients(state) {
      return state.practitionerOwnPatients;
    },
  },
};
